import dev.shanty.kotwire.stimulus.Controller
import dev.shanty.kotwire.stimulus.StimulusController
import kotlinx.browser.window
import org.w3c.dom.HTMLElement

@StimulusController(targets = ["source"])
@JsExport
class CopyController(context: dynamic) : Controller(context) {
    val source by sourceTarget<HTMLElement>()

    @JsName("copy")
    fun copy() {
        window.navigator.clipboard.writeText(source.innerText)
    }
}
